<template>
  <v-bottom-sheet
      v-model="sheet"
      scrollable
      persistent
      no-click-animation
      :overlay-opacity="0.7"
      content-class="bottom-sheet"
  >
    <v-card>
      <SheetHeader title="감정 보기" @sheetClose="sheetClose()"/>
      <v-card-text class="sheet-body pa-0">
        <Thermometer :emotionChoiceArr="emotionChoiceList"
                     :readonly="readonly" ref="ThermometerSheet"/>
      </v-card-text>
    </v-card>
  </v-bottom-sheet>
</template>
<script>
import SheetHeader from "./SheetHeader";
import Thermometer from '@/components/solution/Thermometer'

export default {
  props: {
    sheet: Boolean,
    emotionChoiceList: Array
  },
  data: () => ({
    readonly: true,
  }),
  components: {
    SheetHeader,
    Thermometer,
  },
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {
    sheetClose() {
      this.$emit('close')
    }
  },
}
</script>
